var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.1103 18.1501h-3.78999c-.41 0-.75-.34-.75-.75v-5.1199c0-1.04.84999-1.8901 1.88999-1.8901h2.65c.41 0 .75.34.75.75v6.25c0 .42-.34.76-.75.76zm-3.03999-1.5h2.28998v-4.75h-1.89999c-.21 0-.38999.17-.38999.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.8896 18.1501h-3.79c-.40999 0-.74999-.34-.74999-.75v-9.65999c0-1.04.84999-1.89001 1.88999-1.89001h1.52c1.04 0 1.89.85001 1.89 1.89001v9.65999c-.01.41-.34.75-.76.75zm-3.03-1.5h2.29v-8.90999c0-.21-.17-.39001-.39-.39001h-1.52c-.21 0-.39.17001-.39.39001v8.90999z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.6806 18.1501h-3.79c-.41 0-.75-.34-.75-.75v-4.55c0-.41.34-.75.75-.75h2.65c1.04 0 1.89.85 1.89 1.89v3.41c0 .41-.33.75-.75.75zm-3.04-1.5h2.29v-2.66c0-.21-.17-.39-.39-.39h-1.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15 22.75h-6c-5.43 0-7.75-2.32-7.75-7.75v-6c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75zm-6-20c-4.61 0-6.25 1.64-6.25 6.25v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-6c0-4.61-1.64-6.25-6.25-6.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSquare);
export default __webpack_public_path__ + "static/media/chart-square.ee86d282fca3c7be0de43103be3398a3.svg";
export { ForwardRef as ReactComponent };